// 第4张
const imgAll4 = {
    JP: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1733143212709/Frame%201000008652.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1733143215859/JP%20(1).jpg',
    },
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1733144166418/NA%2BEU.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1733144169812/NA%2BEU%20(1).jpg',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1733191433259/pc.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1733191433059/h5.jpg',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725093142142/uk4.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725093605209/uk4.jpg',
    },
};
export const imgLocale4: any = {
    jp: imgAll4.JP,
    us: imgAll4.NA,
    ca: imgAll4.NA,
    br: imgAll4.NA,
    mx: imgAll4.NA,
    uk: imgAll4.UK,
    eu: imgAll4.EU,
    de: imgAll4.EU,
    fr: imgAll4.EU,
    it: imgAll4.EU,
    es: imgAll4.EU,
    nl: imgAll4.EU,
};
